import { ElementOf, tuple } from '../common/props';
export type ColumnType = ElementOf<typeof ColumnTypes>;
const ColumnTypes = tuple(
  'text',
  'integer',
  'decimal',
  'date',
  'checkBox',
  'currency',
  'currencyDecimal',
  'dateTime',
  'boolean',
  'action'
);
